import axios from 'axios';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://kist-api-prod.mosbahsanad.workers.dev',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API functions
export const agreementApi = {
  // Create a new agreement
  create: async (formData: any) => {
    const response = await api.post('/agreements', {
      ...formData,
      penalty_rule_json: '{"type":"fixed_per_day","amount":1}',
      start_date: new Date(formData.start_date).toISOString(),
    });
    return response.data;
  },

  // Get agreement by ID
  getById: async (id: string) => {
    const response = await api.get(`/agreements/${id}`);
    return response.data;
  },

  // Get agreement by short code
  getByCode: async (shortCode: string) => {
    const response = await api.get(`/agreements/by-code/${shortCode}`);
    return response.data.data; // Extract the data from the response structure
  },

  // Update agreement
  update: async (id: string, data: any) => {
    const response = await api.put(`/agreements/${id}`, data);
    return response.data;
  },

  // Get signature upload URL
  getSignatureUploadUrl: async (id: string) => {
    const response = await api.post(`/agreements/${id}/signature-upload-url`);
    return response.data;
  },

  // Finalize signature
  finalizeSignature: async (id: string, signatureData: any) => {
    const response = await api.post(`/agreements/${id}/finalize-signature`, signatureData);
    return response.data;
  },
};

export const customerApi = {
  // Get customers list
  list: async (params?: any) => {
    const response = await api.get('/customers', { params });
    return response.data;
  },

  // Get customer by ID
  getById: async (id: string) => {
    const response = await api.get(`/customers/${id}`);
    return response.data;
  },

  // Create customer
  create: async (data: any) => {
    const response = await api.post('/customers', data);
    return response.data;
  },

  // Update customer
  update: async (id: string, data: any) => {
    const response = await api.put(`/customers/${id}`, data);
    return response.data;
  },
};

export const branchApi = {
  // Get branches list
  list: async () => {
    const response = await api.get('/branches');
    return response.data;
  },

  // Get branch by ID
  getById: async (id: string) => {
    const response = await api.get(`/branches/${id}`);
    return response.data;
  },
};

export default api; 